import 'nouislider';
import 'awesomplete';
import Scroll from '../library/Scroll';

function init() {
    const headerElement = document.querySelector('.header');
    const smallScreen = (window.innerWidth <= 767) ? true : false;
    const iPhone = (/iPhone/i.test(navigator.userAgent)) ? true : false;
    const noScrollClassName = (iPhone) ? 'noscrollfixed' : 'noscroll';
    let scroll = new Scroll();

    const forms = Array.from(document.querySelectorAll('.propertysearchform'));

    const propertyfilterElement = document.querySelector('.propertyfilter');
    const searchLocationInputs = Array.from(document.querySelectorAll('.propertysearch__searchinput, .mobilepropertysearch__searchinput'));

    const propertysearch = document.querySelector('.propertysearch');

    const dropdownLink = document.querySelector('.propertysearch__searchinput');
    const dropdownCloseLink = document.querySelector('.propertysearch__dropdownclose');
    const dropdownElementWrapper = document.querySelector('.propertysearch__dropdownwrapper');
    const dropdownElement = document.querySelector('.propertysearch__dropdown');
    const dropdownElementOpenClassName = 'propertysearch__dropdownwrapper--open';
    const dropdownLocationCount = Array.from(document.querySelectorAll('.propertysearch__selectinfocount'));
    const dropdownCheckItems = Array.from(document.querySelectorAll('.propertysearch__dropdowncheckitems'));
    const dropdownMapItems = (dropdownElementWrapper) ? Array.from(dropdownElementWrapper.querySelectorAll('.propertysearch__dropdownmapwrapper')) : false;
    const dropdownResetFilterButtons = Array.from(document.querySelectorAll('.propertysearch__dropdownresetfilterlink'));

    const dropdownViewNavigationLinks = Array.from(document.querySelectorAll('.propertysearch__dropdownviewnavigationlink'));
    const dropdownViewNavigationLinksActiveClassName = 'propertysearch__dropdownviewnavigationlink--active';
    const dropdownViews = Array.from(document.querySelectorAll('.propertysearch__dropdownview'));
    const dropdownViewsShowClassName = 'propertysearch__dropdownview--show';
    const dropdownViewDataAttr = 'data-view';

    const dropdownLocationNavigationLinks = Array.from(document.querySelectorAll('.propertysearch__dropdownlocationnavigationlink'));
    const dropdownLocationNavigationLinksActiveClassName = 'button--dropdownlocationnavigationlink--active';
    const dropdownLocationNavigationLinksSelectedClassName = 'button--dropdownlocationnavigationlink--selected';
    const dropdownLocationNavigationLinksHideClassName = 'propertysearch__dropdownlocationnavigationlink--hide';
    const dropdownLocations = Array.from(document.querySelectorAll('.propertysearch__dropdownmain'));
    const dropdownLocationsClassName = 'propertysearch__dropdownmain';
    const dropdownLocationsShowClassName = 'propertysearch__dropdownmain--show';
    const dropdownLocationDataAttr = 'data-view-location';
    const dropdownLocationNavigationShowMoreLink = document.querySelector('.propertysearch__dropdownlocationnavigationshowmorelink');
    const dropdownLocationNavigationShowMoreLinkHideClassName = 'propertysearch__dropdownlocationnavigationshowmorelink--hide';

    const categoryItems = Array.from(document.querySelectorAll('.fakeselect--category .fs-rb'));
    const mobileCategoryItems = Array.from(document.querySelectorAll('.mobilepropertyfilteroverlay__terms-checkbox'));

    const mobilePropertySearchElement = document.querySelector('.mobilepropertysearch');
    const mobilePropertyFilterElement = document.querySelector('.mobilepropertyfilter');
    const mobilePropertyFilterButton = document.querySelector('.mobilepropertyfilter__button--filter');
    const mobilePropertyFilterOverlay = document.querySelector('.mobilepropertyfilteroverlay');
    const mobilePropertyFilterOverlayClose = document.querySelector('.mobilepropertyfilteroverlay__closebutton');
    const mobilePropertyFilterCheckItems = Array.from(document.querySelectorAll('.mobilepropertyfilteroverlay__checkitems'));
    const mobileRoomField = document.querySelector('.mobilepropertyfilteroverlay__contentrowfilterinput--rooms');
    const mobileRoomButtonSub = document.querySelector('.mobilepropertyfilteroverlay__contentrowfilterinputhandle--sub');
    const mobileRoomButtonAdd = document.querySelector('.mobilepropertyfilteroverlay__contentrowfilterinputhandle--add');
    const mobileSearchInput = document.querySelector('.mobilepropertysearch__searchinput');
    const mobileSearchInputReset = document.querySelector('.mobilepropertysearch__searchinputreset');
    const mobileSorting = document.querySelector('.mobilepropertyfilter__sorting');

    const resetSearchBarSelects = () => {
        const resetSelects = Array.from(document.querySelectorAll('.fakeselect--searchbar .fs-rb:checked, .mobilepropertyfilteroverlay__terms-checkbox:checked, .mobilepropertyfilteroverlay__offertype-checkbox:checked'));
        resetSelects.map((select) => {
            select.checked = false;
            select.removeAttribute('checked');
            if ("createEvent" in document) {
                var evt = document.createEvent("HTMLEvents");
                evt.initEvent("change", false, true);
                select.dispatchEvent(evt);
            }
        });
    };

    const sortingInputs = Array.from(document.querySelectorAll('.propertyspecialfilter__sorting .fs-rb'));
    sortingInputs.map((input) => {
        input.addEventListener('change', () => {
            if (window.propertyFilterInitSearchReset) {
                resetSearchBarSelects();
            }
        });
    });

    if (mobileSorting) {
        mobileSorting.addEventListener('change', () => {
            if (window.propertyFilterInitSearchReset) {
                resetSearchBarSelects();
            }
        });
    }

    const singleSelects = Array.from(document.querySelectorAll('[data-single-select]'));
    singleSelects.map((singleSelect) => {
        const type = singleSelect.getAttribute('data-single-select');
        singleSelect.addEventListener('click', () => {
            if (singleSelect.checked) {
                const selects = Array.from(document.querySelectorAll(`[data-single-select=${type}]`));
                selects.map((select) => {
                    if (select !== singleSelect) {
                        select.checked = false;
                    }
                });
            }


        });
    });

    const categorySlugMapping = {
        'init': 'init',
        'residential-ru': 'residential',
        'residential': 'residential',
        'residential-2': 'residential',
        'commercial-ru': 'commercial',
        'commercial-2': 'commercial',
        'commercial': 'commercial',
        'investment-2': 'investment',
        'investment-ru': 'investment',
        'investment': 'investment',
    };

    const getSiblings = function (elem) {
        return Array.prototype.filter.call(elem.parentNode.children, function (sibling) {
            return sibling !== elem;
        });
    };


    // loop all searchstring inputs and add custom autocomplete
    if (!window.searchLocationAwesomplete && searchLocationInputs) {
        searchLocationInputs.map((input) => {
            new Awesomplete(input, {
                list: autocompleteLocations,
            });


        });

    }
    window.searchLocationAwesomplete = true;


    if (searchLocationInputs) {
        searchLocationInputs.map((input) => {
            input.addEventListener('keydown', () => {
                if (input.value !== '' && window.propertyFilterInitSearchReset === true) {
                    window.propertyFilterInitSearchReset = false;
                    resetSearchBarSelects();
                }
            });
        });
    }

    const width = window.innerWidth;

    if (width < 1366) {
        const inputPropertysearch = document.querySelector('.propertysearch__searchinput');
        if (inputPropertysearch) {
            inputPropertysearch.onblur = inputBlur;
            inputPropertysearch.onfocus = inputFocus;
        }


        function inputBlur() {
            propertysearch.classList.add('propertysearch--widget');
        }


        function inputFocus() {
            if (propertysearch.classList.contains('propertysearch--widget')) {
                propertysearch.classList.remove('propertysearch--widget');
                propertysearch.addEventListener('click', function () {
                    this.scrollIntoView();
                    headerElement.classList.add('header--hide');

                    function addScroll() {
                        if (headerElement.classList.contains('header--hide')) {
                            headerElement.classList.remove('header--hide');
                        }

                        window.removeEventListener('scroll', addScroll);
                    }

                    setTimeout(() => {
                        window.addEventListener('scroll', addScroll);
                    }, 1000);

                });
            }
        }
    }


    // add event listener to location dropdown link
    if (!window.dropdownLinkClickHandler && dropdownLink && dropdownElementWrapper) {
        dropdownLink.addEventListener('click', (e) => {
            e.preventDefault();
            dropdownElementWrapper.classList.add(dropdownElementOpenClassName);


            if (propertysearch.classList.contains('propertysearch--widget') && !propertysearch.classList.contains('propertysearch--sticky')) {
                if (window.pageYOffset < dropdownElement.offsetHeight) {
                    let dropdownOpenBottomPosition = window.pageYOffset + dropdownElement.offsetHeight + 50;
                    scroll.top(dropdownOpenBottomPosition, 1000);
                }
            }


            document.addEventListener('click', locationdropdownOutsideClick);
        });
        window.dropdownLinkClickHandler = true;

        // close overlay when clicked outside
        const locationdropdownOutsideClick = function (e) {
            let isClickInside = dropdownElementWrapper.contains(e.target) || dropdownLink.contains(e.target);
            if (!isClickInside) {
                dropdownElementWrapper.classList.remove(dropdownElementOpenClassName);
                document.removeEventListener('click', locationdropdownOutsideClick);
            }
        };

        // close overlay
        if (dropdownCloseLink) {
            dropdownCloseLink.addEventListener('click', (e) => {
                e.preventDefault();
                dropdownElementWrapper.classList.remove(dropdownElementOpenClassName);
            });
        }
    }

    // dropdown locations - reset filters
    if (!window.dropdownResetFilterClickHandler && !smallScreen && dropdownElementWrapper && dropdownResetFilterButtons) {
        dropdownResetFilterButtons.map((button) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                let allLocationCheckboxes = Array.from(dropdownElementWrapper.querySelectorAll('.pqs-dd-location'));
                let allLocationRegions = Array.from(dropdownElementWrapper.querySelectorAll('.map__region'));
                allLocationCheckboxes.map((checkbox) => {
                    checkbox.checked = false;
                });
                allLocationRegions.map((region) => {
                    region.classList.remove('map__region--active');
                });

                setLocationActiveState();
            });
        });
        window.dropdownResetFilterClickHandler = true;
    }

    // change view
    if (dropdownViewNavigationLinks) {
        dropdownViewNavigationLinks.map((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                let linkSiblings = getSiblings(link);
                linkSiblings.map((sibling) => {
                    sibling.classList.remove(dropdownViewNavigationLinksActiveClassName);
                });
                link.classList.add(dropdownViewNavigationLinksActiveClassName);

                let dataView = (link.hasAttribute(dropdownViewDataAttr)) ? link.getAttribute(dropdownViewDataAttr) : false;
                if (dataView) {
                    if (dropdownViews) {
                        dropdownViews.map((view) => {
                            view.classList.remove(dropdownViewsShowClassName);
                            if (view.hasAttribute(dropdownViewDataAttr)) {
                                if (view.getAttribute(dropdownViewDataAttr) === dataView) {
                                    view.classList.add(dropdownViewsShowClassName);
                                }
                            }
                        });
                    }

                    let currentViewsSelection = document.querySelector(`[${dropdownViewDataAttr}="${dataView}"] .${dropdownLocationNavigationLinksActiveClassName}`);
                    if (currentViewsSelection.hasAttribute(dropdownLocationDataAttr)) {
                        document.querySelector(`.${dropdownLocationsClassName}[${dropdownLocationDataAttr}="${currentViewsSelection.getAttribute(dropdownLocationDataAttr)}"]`).classList.add(dropdownLocationsShowClassName);
                    }
                }
            });
        });
    }

    // change location view
    if (dropdownLocationNavigationLinks) {
        dropdownLocationNavigationLinks.map((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                let linkSiblings = getSiblings(link);
                linkSiblings.map((sibling) => {
                    sibling.classList.remove(dropdownLocationNavigationLinksActiveClassName);
                });
                link.classList.add(dropdownLocationNavigationLinksActiveClassName);

                let dataView = (link.hasAttribute(dropdownLocationDataAttr)) ? link.getAttribute(dropdownLocationDataAttr) : false;
                if (dataView) {
                    if (dropdownLocations) {
                        dropdownLocations.map((location) => {
                            location.classList.remove(dropdownLocationsShowClassName);
                            if (location.hasAttribute(dropdownLocationDataAttr)) {
                                if (location.getAttribute(dropdownLocationDataAttr) === dataView) {
                                    location.classList.add(dropdownLocationsShowClassName);
                                    const locationCheckboxes = Array.from(location.querySelectorAll('.propertysearch__dropdowncheckitem'));
                                    if (locationCheckboxes.length === 1) {
                                        const checkbox = locationCheckboxes[0].querySelector('input');
                                        checkbox.checked = true;
                                        changeRegionCheckboxAndMapStates('checkboxHandle', checkbox, false);
                                    }
                                }
                            }
                        });
                    }
                }

                setLocationActiveState();
            });
        });
    }

    setLocationActiveState();

    function setLocationActiveState() {
        if (dropdownLocationNavigationLinks) {
            dropdownLocationNavigationLinks.map((link) => {
                let dataView = (link.hasAttribute(dropdownLocationDataAttr)) ? link.getAttribute(dropdownLocationDataAttr) : false;
                if (dataView) {
                    const checkboxes = Array.from(document.querySelectorAll(`.propertysearch__dropdownmain[${dropdownLocationDataAttr}=${dataView}] input:checked`));
                    if (checkboxes.length > 0) {
                        link.classList.add(dropdownLocationNavigationLinksSelectedClassName);
                    } else {
                        link.classList.remove(dropdownLocationNavigationLinksSelectedClassName);
                    }
                }
            });
        }
    }

    // shopw more locations
    if (dropdownLocationNavigationShowMoreLink) {
        dropdownLocationNavigationShowMoreLink.addEventListener('click', function (e) {
            e.preventDefault();
            dropdownLocationNavigationLinks.map((link) => {
                link.classList.remove(dropdownLocationNavigationLinksHideClassName);
            });
            this.classList.add(dropdownLocationNavigationShowMoreLinkHideClassName);
        });
    }

    // loop ALL location dropdown checkboxes and display count
    if (!smallScreen && dropdownElementWrapper && dropdownLocationCount) {
        let allLocationCheckboxes = Array.from(dropdownElementWrapper.querySelectorAll('.pqs-dd-location'));
        let selectinfocountwrapper = Array.from(document.querySelectorAll('.propertysearch__selectinfocountwrapper'));
        let selectinfocountwrapperShowClassName = 'propertysearch__selectinfocountwrapper--show';
        setInterval(() => {
            updateLocationCount();
        }, 500);

        function updateLocationCount() {
            let count = 0;
            allLocationCheckboxes.map((checkbox) => {
                if (checkbox.checked) {
                    count++;
                }
            });

            if (count > 0) {
                dropdownLocationCount.map((countElement) => {
                    countElement.innerHTML = count;
                });
                selectinfocountwrapper.map((wrapper) => {
                    wrapper.classList.add(selectinfocountwrapperShowClassName);
                });
            } else {
                dropdownLocationCount.map((countElement) => {
                    countElement.innerHTML = '';
                });
                selectinfocountwrapper.map((wrapper) => {
                    wrapper.classList.remove(selectinfocountwrapperShowClassName);
                });
            }
        }
    }

    // loop locations
    if (!window.dropdownCheckItemsClickHandler && !smallScreen && dropdownCheckItems) {
        dropdownCheckItems.map((location) => {
            let checkboxes = Array.from(location.querySelectorAll('.pqs-dd-map'));
            let map = document.querySelector(`.map[data-location="${location.getAttribute('data-map')}"]`);

            // loop location checkboxes
            if (checkboxes) {
                checkboxes.map((checkbox) => {
                    let region = (map) ? map.querySelector(`.map__region[data-region="${checkbox.getAttribute('data-region')}"]`) : false;
                    //initial check
                    if (checkbox.checked) {
                        changeRegionCheckboxAndMapStates('checkboxHandle', checkbox, region);
                    }
                    //update check
                    checkbox.addEventListener('change', (e) => {
                        changeRegionCheckboxAndMapStates('checkboxHandle', checkbox, region);
                    });
                });
            }
        });
        window.dropdownCheckItemsClickHandler = true;
    }

    //loop maps
    if (!window.dropdownMapItemsClickHandler && !smallScreen && dropdownMapItems) {
        dropdownMapItems.map((maplocation) => {
            let regions = Array.from(maplocation.querySelectorAll('.map__region'));
            let map = maplocation.querySelector('.map');
            let mapName = (map.hasAttribute('data-location')) ? map.getAttribute('data-location') : '';
            let location = document.querySelector(`.propertysearch__dropdowncheckitems[data-map="${mapName}"]`);

            // loop map regions
            if (regions) {
                regions.map((region) => {
                    region.addEventListener('click', (e) => {
                        let regionName = region.getAttribute('data-region');
                        let checkbox = location.querySelector(`.pqs-dd-map[data-region="${regionName}"]`);
                        changeRegionCheckboxAndMapStates('mapHandle', checkbox, region);
                    });
                });
            }

            //map select all
            let selectAllButtons = maplocation.querySelector('.propertysearch__selectalllink');
            if (selectAllButtons) {
                selectAllButtons.addEventListener('click', (e) => {
                    e.preventDefault();
                    changeAllRegionCheckboxesAndMapStates(location, map);
                });
            }
        });
        window.dropdownMapItemsClickHandler = true;
    }

    function changeRegionCheckboxAndMapStates(handle, checkbox, region) {
        if (region) {
            if (handle == 'checkboxHandle') {
                if (checkbox.checked) {
                    region.classList.add('map__region--active');
                } else {
                    region.classList.remove('map__region--active');
                }
            } else if (handle == 'mapHandle') {
                region.classList.toggle('map__region--active');
                checkbox.checked = (!checkbox.checked) ? true : false;
            }
        }
    }

    function changeAllRegionCheckboxesAndMapStates(location, map) {
        let locationName = location.closest('.propertysearch__dropdowncheckitems');
        let checkboxes = Array.from(locationName.querySelectorAll('.pqs-dd-location'));
        let regions = (map) ? Array.from(map.querySelectorAll('.map__region')) : false;

        if (checkboxes) {
            checkboxes.map((checkbox) => {
                checkbox.checked = true;
            });
        }

        if (regions) {
            regions.map((region) => {
                region.classList.add('map__region--active');
            });
        }
    }

    let initialSelectedCategory = 'init';

    // category mapping
    categoryItems.map((item) => {
        if (item.checked) {
            initialSelectedCategory = item.getAttribute('name');
        }
        item.addEventListener('click', (e) => {
            let selectedCategory = 'init';
            if (item.checked) {
                selectedCategory = item.getAttribute('name');
            }
            categoryMapping(selectedCategory);
        });
    });
    // category mapping
    mobileCategoryItems.map((item) => {
        item.addEventListener('change', (e) => {
            let selectedCategory = 'init';
            if (item.checked) {
                selectedCategory = item.getAttribute('name');
            }
            categoryMapping(selectedCategory);
        });
    });
    categoryMapping(initialSelectedCategory);


    // do the filter range sliders
    if (!window.filterRangeSliders && forms.length > 0 && (propertyfilterElement || mobilePropertyFilterElement)) {
        const filters = [{
            name: 'price',
        }, {
            name: 'livingarea',
        }, {
            name: 'price--mobile',
        }, {
            name: 'livingarea--mobile',
        }];

        filters.map((filter) => {
            let filterslider = document.querySelector(`.propertyfilter__filterslider--${filter.name}`);
            if (!filterslider) {
                return;
            }
            let sliderMinElement = document.querySelector(`.propertyfilter__filterfield--${filter.name}--min`);
            let sliderMaxElement = document.querySelector(`.propertyfilter__filterfield--${filter.name}--max`);
            let sliderMin = (sliderMinElement) ? parseInt(sliderMinElement.getAttribute('data-min')) : 0;
            let sliderMax = (sliderMaxElement) ? parseInt(sliderMaxElement.getAttribute('data-max')) : 0;
            let sliderCeil = (sliderMaxElement) ? parseInt(sliderMaxElement.getAttribute('data-ceil')) : 0;
            let steps = (sliderMinElement) ? parseInt(sliderMinElement.getAttribute('data-step')) : 0;
            let start = (sliderMinElement.value == sliderMin) ? sliderMin : parseInt(sliderMinElement.value);
            let end = (sliderMaxElement.value == sliderMax) ? sliderMax : parseInt(sliderMaxElement.value);
            let mobileFakeInputMinElement = document.querySelector(`.propertyfilter__filterfieldfake--${filter.name}--min span`);
            let mobileFakeInputMaxElement = document.querySelector(`.propertyfilter__filterfieldfake--${filter.name}--max span`);

            window.priceSliderMaxElement = document.querySelector(`.propertyfilter__filterfield--price--max`);
            window.priceSliderCeil = (window.priceSliderMaxElement) ? parseInt(window.priceSliderMaxElement.getAttribute('data-ceil')) : 0;

            if (filterslider && sliderMinElement && sliderMaxElement && Number.isInteger(sliderMin) && Number.isInteger(sliderMax)) {
                // slider handling
                noUiSlider.create(filterslider, {
                    start: [start, end],
                    step: steps,
                    connect: true,
                    range: {
                        'min': sliderMin,
                        'max': sliderMax,
                    },
                }).on('update', function (values, handle) {
                    sliderMinElement.value = addThousandsDots(parseInt(values[0]));
                    sliderMaxElement.value = addThousandsDots(parseInt(values[1]), sliderMax);

                    if (mobileFakeInputMinElement && mobileFakeInputMaxElement) {
                        mobileFakeInputMinElement.innerHTML = addThousandsDots(parseInt(values[0]));
                        mobileFakeInputMaxElement.innerHTML = addThousandsDots(parseInt(values[1]), sliderMax);
                    }
                });

                // input event listeners
                sliderMinElement.addEventListener('focus', (e) => {
                    sliderMinElement.value = removeThousandsDots(sliderMinElement.value);
                });
                sliderMinElement.addEventListener('focusout', (e) => {
                    sliderMinElement.value = addThousandsDots(sliderMinElement.value);
                });
                sliderMinElement.addEventListener('change', (e) => {
                    filterslider.noUiSlider.set([sliderMinElement.value, null]);
                });

                sliderMaxElement.addEventListener('focus', (e) => {
                    sliderMaxElement.value = removeThousandsDots(sliderMaxElement.value);
                });
                sliderMaxElement.addEventListener('focusout', (e) => {
                    sliderMaxElement.value = addThousandsDots(sliderMaxElement.value, sliderMax);
                });
                sliderMaxElement.addEventListener('change', (e) => {
                    filterslider.noUiSlider.set([null, sliderMaxElement.value]);
                });
            }
            window.filterRangeSliders = true;
        });

    }


    // mobile sticky search and filter
    if (smallScreen && headerElement) {
        if (mobilePropertySearchElement) {
            mobilePropertySearchElement.style.top = headerElement.offsetHeight + 'px';
        }
        if (mobilePropertySearchElement && mobilePropertyFilterElement) {
            mobilePropertyFilterElement.style.top = headerElement.offsetHeight + mobilePropertySearchElement.offsetHeight + 'px';
        }
    }

    // mobile - add event listener to filter button
    if (!window.mobilePropertyFilterClickHandler && smallScreen && mobilePropertyFilterButton && mobilePropertyFilterOverlay) {
        mobilePropertyFilterButton.addEventListener('click', (e) => {
            e.preventDefault();
            document.body.classList.add(noScrollClassName);
            mobilePropertyFilterOverlay.classList.add('mobilepropertyfilteroverlay--open');
        });
        window.mobilePropertyFilterClickHandler = true;
    }

    // mobile - add event listener to filter overlay close button
    if (!window.mobilePropertyFilterOverlayCloseClickHandler && smallScreen && mobilePropertyFilterOverlayClose && mobilePropertyFilterOverlay) {
        mobilePropertyFilterOverlayClose.addEventListener('click', (e) => {
            e.preventDefault();
            document.body.classList.remove(noScrollClassName);
            mobilePropertyFilterOverlay.classList.remove('mobilepropertyfilteroverlay--open');
        });
        window.mobilePropertyFilterOverlayCloseClickHandler = true;
    }

    // mobile - add filter unselectAll checkbox functionality
    if (!window.mobileUnselectAllClickHandler && smallScreen && mobilePropertyFilterCheckItems) {
        mobilePropertyFilterCheckItems.map((item) => {
            let unSelectAllButton = item.querySelector('.mobilepropertyfilteroverlay__unselectall');
            if (unSelectAllButton) {
                unSelectAllButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    let checkboxes = Array.from(item.querySelectorAll('.mobilepropertyfilteroverlay__contentrowfiltercheckbox'));
                    if (checkboxes) {
                        checkboxes.map((checkbox) => {
                            checkbox.checked = false;
                        });
                    }
                });
            }
        });
        window.mobileUnselectAllClickHandler = true;
    }

    // mobile - rooms filter handles
    if (!window.mobileRoomsClickHandler && smallScreen && mobileRoomField && mobileRoomButtonSub && mobileRoomButtonAdd) {
        mobileRoomButtonSub.addEventListener('click', (e) => {
            e.preventDefault();
            updateRoomsValue('sub');
        });
        mobileRoomButtonAdd.addEventListener('click', (e) => {
            e.preventDefault();
            updateRoomsValue('add');
        });

        function updateRoomsValue(mode) {
            let roomsMin = mobileRoomField.getAttribute('data-min');
            let roomsMax = mobileRoomField.getAttribute('data-max');
            if (roomsMin && roomsMax) {
                let currentValue = parseInt(mobileRoomField.value);
                if (mode === 'sub') {
                    mobileRoomField.value = (currentValue > roomsMin) ? currentValue - 1 : currentValue;
                } else if (mode === 'add') {
                    mobileRoomField.value = (currentValue < roomsMax) ? currentValue + 1 : currentValue;
                }
            }
            return false;
        }

        window.mobileRoomsClickHandler = true;
    }


    // do stuff when form(s) submit
    if (!window.formSubmitClickHandler && forms.length > 0) {
        forms.map((form) => {

            // get all submit buttons and add event listener
            let submitButtons = Array.from(form.querySelectorAll('[type="submit"]'));
            submitButtons.map((submitButton) => {
                submitButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    formSubmitFunctions(form);
                });
            });

            // trigger submitfunctions when fields (labels) clicked
            let submitHandlerFields = Array.from(form.querySelectorAll('.click--submit'));
            if (submitHandlerFields) {
                submitHandlerFields.map((field) => {
                    field.addEventListener('click', (e) => {
                        setTimeout(function () {
                            formSubmitFunctions(form);
                        }, 300);
                    });
                });
            }

            const mobileSortingSelect = form.querySelector('.mobilepropertyfilter__sorting');
            if (mobileSortingSelect) {
                mobileSortingSelect.addEventListener('change', () => {
                    formSubmitFunctions(form);
                });
            }

            // get all category filter buttons and add event listener
            let propertyCategoryButtons = Array.from(form.querySelectorAll('.button--searchcategory'));
            if (propertyCategoryButtons) {
                propertyCategoryButtons.map((button) => {
                    button.addEventListener('click', (e) => {
                        e.preventDefault();
                        let propertyCategoryHiddenInputs = Array.from(form.querySelectorAll('.pc-option'));
                        propertyCategoryHiddenInputs.map((input) => {
                            input.value = 0;
                        });
                        let relatedHiddenInput = document.querySelector(`#pc-${button.getAttribute('data-pc')}`);
                        relatedHiddenInput.value = (relatedHiddenInput.value == 1) ? 0 : 1;
                        formSubmitFunctions(form);
                    });
                });
            }

            // get all category filter buttons and add event listener
            let propertySellTypeButtons = Array.from(form.querySelectorAll('.button--selltype'));
            if (propertySellTypeButtons) {
                propertySellTypeButtons.map((button) => {
                    button.addEventListener('click', (e) => {
                        window.priceSliderMaxElement.value = window.priceSliderCeil;
                        e.preventDefault();
                        let relatedHiddenInput = document.querySelector(`#st-${button.getAttribute('data-st')}`);
                        relatedHiddenInput.value = (relatedHiddenInput.value == 1) ? 0 : 1;
                        formSubmitFunctions(form);
                    });
                });
            }

            // mobile - reset searchstring input
            if (mobileSearchInputReset && mobileSearchInput) {
                mobileSearchInputReset.addEventListener('click', (e) => {
                    e.preventDefault();
                    mobileSearchInput.value = '';
                    formSubmitFunctions(form);
                });
            }
        });
        window.formSubmitClickHandler = true;
    }

    // Do stuff and submit the form
    function formSubmitFunctions(form) {

        // Set real name attribute to searchstring input
        if (searchLocationInputs) {
            searchLocationInputs.map((input) => {
                let realNameAttr = input.getAttribute('data-name');
                if (realNameAttr !== '') {
                    input.setAttribute('name', realNameAttr);
                }
            });
        }

        // Remove dots from number fields
        let numberInputFields = Array.from(form.querySelectorAll('.inputtext--number'));
        if (numberInputFields) {
            numberInputFields.map((field) => {
                field.value = removeThousandsDots(field.value);
            });
        }

        //submit the form
        form.submit();
    }

    // Unselect filters custom select checkboxes
    function unselectFilterCSCheckboxes(filterMod = '', catSlug = '') {
        const filterElementClass = `.propertyfilter__filter--${filterMod}`;

        if(filterMod == 'propertytype'){
            if (filterElementClass) {
                const checkboxes = Array.from(document.querySelectorAll(`${filterElementClass} .cs-cb`));
                const selectCount = document.querySelector(`${filterElementClass} .customselect__count`);
                const allText = document.querySelector(`${filterElementClass} .customselect__alltext`);
                const curCat = catSlug != '' ? catSlug.replace('-2','') : '';
                var cbCount = 0;

               if (checkboxes) {
                    checkboxes.map(function (checkbox) {
                      const classList = String(checkbox.parentElement.parentElement.classList);
                      if(checkbox.checked == true && classList.includes(curCat)){
                        checkbox.checked = true;
                        cbCount++;
                      }else{
                        checkbox.checked = false;
                      }
                    });
                }
                if (selectCount) {
                    selectCount.innerHTML = cbCount;
                    selectCount.classList.add('customselect__count--show');
                }
                if (allText) {
                    allText.classList.remove('customselect__alltext--show');
                }
            }
        }else{
            if (filterElementClass) {
                const checkboxes = Array.from(document.querySelectorAll(`${filterElementClass} .cs-cb`));
                const selectCount = document.querySelector(`${filterElementClass} .customselect__count`);
                const allText = document.querySelector(`${filterElementClass} .customselect__alltext`);
                if (checkboxes) {
                    checkboxes.map((checkbox) => {
                        checkbox.checked = false;
                    });
                }
                if (selectCount) {
                    selectCount.innerHTML = '0';
                    selectCount.classList.add('customselect__count--show');
                }
                if (allText) {
                    allText.classList.remove('customselect__alltext--show');
                }
            }
        }

    }

    // Changes needed with selected category (mapping)
    function categoryMapping(catSlug = 'init') {

        // map labeltexts
        const labelTextsShowClassName = 'labeltext--show';
        const mobileTextsShowClassName = 'mobilepropertyfilteroverlay__contentrowheadline--multiple-show';
        const labelTexts = Array.from(document.querySelectorAll('.propertyfilter .labeltext'));
        const mobileLabelTexts = Array.from(document.querySelectorAll('.mobilepropertyfilteroverlay__contentrowheadline--multiple'));

        const mappedCat = categorySlugMapping[catSlug];
        const cat = mappedCat ? mappedCat : catSlug;


        const catLabelTexts = Array.from(document.querySelectorAll(`.propertyfilter .labeltext--${cat}`));
        labelTexts.map((text) => {
            text.classList.remove(labelTextsShowClassName);
        });
        catLabelTexts.map((text) => {
            text.classList.add(labelTextsShowClassName);
        });

        const mobileCatLabelTexts = Array.from(document.querySelectorAll(`.mobilepropertyfilteroverlay__contentrowheadline--${cat}`));
        mobileLabelTexts.map((text) => {
            text.classList.remove(mobileTextsShowClassName);
        });
        mobileCatLabelTexts.map((text) => {
            text.classList.add(mobileTextsShowClassName);
        });

        // map property types
        const propertyTypesShowClassName = 'customselect__dropdownitem--show';
        const mobilePropertyTypesShowClassName = 'mobilepropertyfilteroverlay__contentrowfilter--show';
        const propertyTypes = Array.from(document.querySelectorAll('.propertyfilter__filter--propertytype .customselect__dropdownitem, .mobilepropertyfilteroverlay__contentrowfilter--hideable'));
        const catPropertyTypes = Array.from(document.querySelectorAll(`.propertyfilter__filter--propertytype .customselect__dropdownitem--${cat}, .mobilepropertyfilteroverlay__contentrowfilter--${cat}`));
        if (cat === 'init') {
            propertyTypes.map((item) => {
                const showClass = item.classList.contains('mobilepropertyfilteroverlay__contentrowfilter--hideable') ? mobilePropertyTypesShowClassName : propertyTypesShowClassName;
                item.classList.add(showClass);
            });
        } else {
            propertyTypes.map((item) => {
                const showClass = item.classList.contains('mobilepropertyfilteroverlay__contentrowfilter--hideable') ? mobilePropertyTypesShowClassName : propertyTypesShowClassName;
                item.classList.remove(showClass);
            });
            unselectFilterCSCheckboxes('propertytype', catSlug);
        }
        catPropertyTypes.map((item) => {
            const showClass = item.classList.contains('mobilepropertyfilteroverlay__contentrowfilter--hideable') ? mobilePropertyTypesShowClassName : propertyTypesShowClassName;
            item.classList.add(showClass);
        });

        // map rooms
        const roomsCheckboxes = Array.from(document.querySelectorAll('.propertyfilter__filter--rooms .fs-rb'));

        // map equipment/features
        const filterDisabledClassName = 'propertyfilter__filter--disabled';
        const mobileFilterDisabledClassName = 'mobilepropertyfilteroverlay__contentrow--disabled';
        const equipmentFilter = document.querySelector('.propertyfilter__filter--equipment');
        const mobileEquipmentFilter = document.querySelector('.mobilepropertyfilteroverlay__contentrow--equipment');


        switch (cat) {
            case 'residential':
                if (roomsCheckboxes) roomsCheckboxes.map((cb) => {
                    cb.setAttribute('name', 'bedrooms');
                });
                if (equipmentFilter) equipmentFilter.classList.remove(filterDisabledClassName);
                if (mobileEquipmentFilter) {
                    mobileEquipmentFilter.classList.remove(mobileFilterDisabledClassName);
                    Array.from(mobileEquipmentFilter.querySelectorAll('input')).map((ftIn) => {
                        ftIn.disabled = false;
                    });
                }
                break;

            case 'commercial':
                if (roomsCheckboxes) roomsCheckboxes.map((cb) => {
                    cb.setAttribute('name', 'rooms');
                });
                if (equipmentFilter) equipmentFilter.classList.add(filterDisabledClassName);
                if (mobileEquipmentFilter) {
                    mobileEquipmentFilter.classList.add(mobileFilterDisabledClassName);
                    Array.from(mobileEquipmentFilter.querySelectorAll('input')).map((ftIn) => {
                        ftIn.disabled = true;
                        ftIn.checked = false;
                    });
                }
                if (equipmentFilter) unselectFilterCSCheckboxes('equipment');
                break;

            case 'investment':
                if (roomsCheckboxes) roomsCheckboxes.map((cb) => {
                    cb.setAttribute('name', 'rooms');
                });
                if (equipmentFilter) equipmentFilter.classList.add(filterDisabledClassName);
                if (mobileEquipmentFilter) {
                    mobileEquipmentFilter.classList.add(mobileFilterDisabledClassName);
                    Array.from(mobileEquipmentFilter.querySelectorAll('input')).map((ftIn) => {
                        ftIn.disabled = true;
                        ftIn.checked = false;
                    });
                }
                if (equipmentFilter) unselectFilterCSCheckboxes('equipment');
                break;

            default:
                if (roomsCheckboxes) roomsCheckboxes.map((cb) => {
                    cb.setAttribute('name', 'rooms');
                });
                if (equipmentFilter) equipmentFilter.classList.remove(filterDisabledClassName);
                if (mobileEquipmentFilter) {
                    mobileEquipmentFilter.classList.remove(mobileFilterDisabledClassName);
                    Array.from(mobileEquipmentFilter.querySelectorAll('input')).map((ftIn) => {
                        ftIn.disabled = false;
                    });
                }
        }
    }

    // Adds dots as "thousand" seperator to a number
    function addThousandsDots(number, maxValue = null, minValue = null) {
        const formattedNumber = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        if (maxValue !== null && maxValue <= number) {
            return formattedNumber + '+';
        }

        if (minValue !== null && minValue >= number) {
            return formattedNumber + '-';
        }
        return formattedNumber;
    }

    // Removes dots seperator from a numbers
    function removeThousandsDots(number) {
        return number.split('.').join('').replace('+', '').replace('-', '');
    }

}

export default init;



// WEBPACK FOOTER //
// ./wp-content/themes/template/res/js/modules/Propertysearch.js